// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2107 ? "vendor.prosemirror-tables" : chunkId) + "." + {"2107":"dfddaa61d14575a0a83f","6980":"5a3ae39e2231db894734"}[chunkId] + ".js";
};